import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { replace } from "connected-react-router";
import { func, number, shape } from "prop-types";
import { bool, string } from "yup";
import { isEmpty } from "lodash";

import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import { actions as menuActions } from "reducers/drawer";

import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import PageLoading from "pages/_components/PageLoading";
import I18n from "pages/_components/I18n";
import Options from "pages/accounts/_components/Options";
import AccountAction from "pages/accounts/_components/AccountAction";
import CustomProductHead from "pages/_components/CustomProductHead";
import Button from "pages/_components/Button";
import ViewTitle from "pages/_components/header/components/ViewTitle";
import classNames from "classnames";
import Image from "pages/_components/Image";
import gaEventTracker, { events } from "util/gaEventTracker";
import { isIOS, isMobile } from "react-device-detect";
import CustomText from "pages/_components/CustomText/CustomText";
import AgreementsList from "./_components/AgreementsList";

class Agreements extends Component {
    static propTypes = {
        account: shape({
            idProduct: string,
            productType: string.isRequired,
            extraInfoMarked: string,
        }).isRequired,
        agreements: shape({}).isRequired,
        dispatch: func.isRequired,
        fetching: bool.isRequired,
        idAccount: string.isRequired,
        isDesktop: bool.isRequired,
        totalAgreements: number.isRequired,
        fetchingAgreements: bool.isRequired,
    };

    componentDidMount() {
        const { dispatch, ...rest } = this.props;
        dispatch(accountsActions.readAccount(rest.match.params.id));
        dispatch(accountsActions.agreements(rest.match.params.id, "2022-05-05T21:46:56.920Z"));
        this.setState({});
        gaEventTracker.triggerEvent(events.cuentas_ver_acuerdo());
    }

    handleBack = () => {
        const { dispatch, ...rest } = this.props;

        dispatch(replace(`/accounts/${rest.match.params.id}`));
    };

    handleClick = () => {
        const { dispatch } = this.props;

        dispatch(menuActions.menuShow());
    };

    render() {
        const { account, fetching, isDesktop, totalAgreements, fetchingAgreements, ...rest } = this.props;

        const ProductInfo = () => {
            const { accountNumber } = account;
            const types = { CA: "savings", CC: "checking", CE: "special", CBB: "CBB" };
            const numberMasked = ` Nº ····${accountNumber?.slice(-4)}`;

            return (
                <>
                    <div
                        className={
                            isIOS || isMobile
                                ? "mb-5 py-5 acct-number d-flex justify-between box box-primary box-text-primary"
                                : "account-type"
                        }>
                        <CustomText text={`accounts.productType.${types[account.productType]}`} textType="I18N" />
                        <CustomText className="content-data-strong" text={numberMasked} />
                    </div>
                </>
            );
        };

        const renderMenuOption = () => (
            <>
                {isDesktop ? (
                    <>
                        <div className="toolbar-item add-button" key="add">
                            <Link
                                className={classNames({
                                    "btn btn-primary btn-block": isDesktop,
                                    "toolbar-btn view-close": !isDesktop,
                                })}
                                to={`/accounts/${rest.match.params.id}/agreements/request`}>
                                <Image src="images/figma/icon/nuevo.svg" className="svg-icon" />
                                <I18n
                                    id="accounts.agreements.new"
                                    componentProps={!isDesktop && { className: "visually-hidden" }}
                                />
                            </Link>
                        </div>
                    </>
                ) : (
                    <div className="toolbar-item commands-mobile">
                        <Button
                            className="toolbar-btn view-options"
                            onClick={this.handleClick}
                            image={isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-ios.svg"}
                            label="view more options"
                            block={false}
                            bsStyle="link"
                        />
                    </div>
                )}
            </>
        );

        return (
            <PageLoading loading={fetching || fetchingAgreements}>
                <Fragment>
                    <CustomProductHead
                        titleId="accounts.agreements.title"
                        onBack={this.handleBack}
                        className="movement-details"
                        renderMenuOption={renderMenuOption}>
                        <div className="toolbar-item view-title">
                            <ViewTitle id="accounts.agreements.title" />
                        </div>
                    </CustomProductHead>
                    <MainContainer showLoader={fetching} className="mt-0">
                        <Notification scopeToShow="account/agreements" />
                        {!isEmpty(account) && <ProductInfo account={account} />}
                        <AgreementsList isDesktop={isDesktop} />
                    </MainContainer>
                </Fragment>
                {!isDesktop && (
                    <Options>
                        <AccountAction
                            isDesktop={isDesktop}
                            labelKey="accounts.agreements.new"
                            to={`/accounts/${rest.match.params.id}/agreements/request`}
                        />
                    </Options>
                )}
            </PageLoading>
        );
    }
}

const mapStateToProps = (state) => ({
    account: accountsSelectors.getSelectedAccount(state),
    agreements: accountsSelectors.getAgreements(state),
    fetching: accountsSelectors.getFetching(state),
    totalAgreements: accountsSelectors.getTotalAgreements(state),
    fetchingAgreements: accountsSelectors.getFetchingAgreements(state),
});

export default connect(mapStateToProps)(Agreements);
